<h1 class="text-center" mat-dialog-title>{{data.title | translate}}</h1>
<div mat-dialog-content fxLayout="column">
    <mat-radio-group class="mx-auto my-2" fxFlex fxLayoutGap="12px" [(ngModel)]="dataType">
        <mat-radio-button *ngFor="let type of exportDataTypes" [value]="type" >
            {{type | uppercase}}
        </mat-radio-button>
    </mat-radio-group>
    <app-cron-generator *ngIf="data.isSchedule" (cronGenerated)="setCron($event)"></app-cron-generator>
    <app-report-filename-editor #fileNameEditor (paramSelected)="fileName = $event" [isSchedule]="data.isSchedule"></app-report-filename-editor>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>{{'close' | translate}}</button>
    <button mat-raised-button color="sims" (click)="onSubmit()" [disabled]="!canSubmit() || fileNameEditor.edit">{{'submit' | translate}}</button>
</div>